import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HttpErrorHandler } from '../shared/http-error-handler';

import { DashboardService } from '../_services/dashboard.service';

import { Profile } from '../_models/profile';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass'],
})
export class DashboardComponent implements OnInit {
  statistics: any = {};
  profile: Profile;

  constructor(private router: Router, private dashboardService: DashboardService, private httpErrorHandler: HttpErrorHandler) {}

  ngOnInit() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.getStatistics();
  }

  getStatistics() {
    this.dashboardService.getStatistics().subscribe(
      (data) => {
        this.statistics = data;
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts